import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InviteCodeResolver  {
  resolve(route: import('@angular/router').ActivatedRouteSnapshot): Observable<string> {
    return of(route.queryParamMap.get('invite'));
  }
}
